import { combineReducers, StateFromReducersMapObject } from 'redux';

import integrations from './integrations.js';

const rootReducer = combineReducers({
  integrations,
});

export type RootState = StateFromReducersMapObject<typeof rootReducer>;

export default rootReducer;
